import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { loaderInterceptor } from './utils/loader-interceptor-utils/loader.interceptor';
import { ControlCenterService } from './services/control-center/control-center.service';
import { LoaderService } from './services/loader-service/loader.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { MasterDataInboundService } from './services/master-data-inbound/master-data-inbound.service';
import { MasterDataServiceService } from './services/master-data-outbound/master-data-service.service';
import { SnackBarService } from './services/snackbar-service/snack-bar.service';
import { routes } from './app.routes';
import { OKTA_AUTH, OKTA_CONFIG } from '@okta/okta-angular';
import { oktaAuth } from './config/okta-config';
import OktaAuth from '@okta/okta-auth-js';
import { Interceptor } from './services/apigee-service/apigee-interceptor';


export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    importProvidersFrom(MatSnackBarModule),
    importProvidersFrom(MatDialog),

    {
      provide: OKTA_CONFIG,
      useValue: { oktaAuth }
    },

    {
      provide: OKTA_AUTH,
      useValue:  oktaAuth 
    },
    
    ControlCenterService,
    MasterDataServiceService,
    LoaderService,
    SnackBarService,
    MasterDataInboundService,
    
    provideHttpClient(withInterceptorsFromDi()),
 
    // Register the interceptors using DI
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true
    },
    provideHttpClient(
      withInterceptors([loaderInterceptor])
    )
  ]
};